<form #form="ngForm"
      method="POST">
    @switch (!!coupon) {
    <!-- current coupon -->
    @case (true) {
    <div class="p-l p-r p-t-3 p-b-3">
        <p class="p2">
            {{'Voucher' | translate}}&nbsp;<span class="s2">{{couponLabel}}</span>&nbsp;{{'has been applied' |
            translate}}
        </p>
        <!-- remove coupon button -->
        <button class="m-t-2"
                [buttonStyle]="'inlineButton'"
                (click)="remove()"
                [status]="removeStatus"><span class="normal-case">{{ 'Click here to remove' | translate
                }}</span></button>
        <result class="block"
                [status]="removeStatus"></result>
    </div>
    }
    <!-- voucher form -->
    @default {
    <div class="bg-col-51 b-radius-4 bg-col-w-m bg-col-w-s p-t-1 p-b-1">
        <expandable [expandableTitle]="'Have you got a promo code' | translate"
                    [expandableLayout]="'filled'"
                    #expandableComponent>
            <form-mui-field class="block p-t-5"
                            [label]="('Enter an offer code'| translate)">
                <input class="bg-col-5"
                       type="text"
                       name="coupon"
                       [(ngModel)]="data.coupon"
                       (keydown.enter)="submit()"
                       required />
            </form-mui-field>
            <!-- submit -->
            <div class="m-t-2">
                <div class="w-6 p-r-1">
                    <button [buttonStyle]
                            class="w-12"
                            (click)="submit()"
                            [status]="status">
                        {{ 'Apply' | translate}}
                    </button>
                </div>
                <div class="w-6 p-l-1">
                    <button [buttonStyle]="'button-1'"
                            class="w-12"
                            zippyToggle="couponForm"
                            (click)="expandableComponent.toggle()">
                        {{ 'Cancel' | translate}}
                    </button>
                </div>
            </div>
            <result [status]="status"></result>
        </expandable>
    </div>
    }
    }
</form>